import React from 'react';

const UploadCloudIcon = ({ color = '#4285F4', size = 48 }) => {
  return (
    <svg 
      width={size} 
      height={Math.round(size * 35/43)} 
      viewBox="0 0 43 35" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M10.9999 27.4999C8.50447 27.4999 6.11123 26.5517 4.34668 24.8639C2.58213 23.176 1.59082 20.8869 1.59082 18.4999C1.59082 16.113 2.58213 13.8238 4.34668 12.1359C6.11123 10.4481 8.50447 9.4999 10.9999 9.4999C11.5893 6.87426 13.3134 4.56687 15.7931 3.08533C17.0209 2.35175 18.3972 1.843 19.8435 1.58813C21.2897 1.33326 22.7776 1.33726 24.2221 1.5999C25.6667 1.86255 27.0396 2.37869 28.2625 3.11886C29.4854 3.85903 30.5343 4.80874 31.3494 5.91376C32.1645 7.01878 32.7298 8.25746 33.013 9.5591C33.2962 10.8607 33.2917 12.1998 32.9999 13.4999H34.9999C36.8564 13.4999 38.6369 14.2374 39.9497 15.5502C41.2624 16.8629 41.9999 18.6434 41.9999 20.4999C41.9999 22.3564 41.2624 24.1369 39.9497 25.4497C38.6369 26.7624 36.8564 27.4999 34.9999 27.4999H32.9999M14.9999 21.5L20.9999 15.5M20.9999 15.5L26.9999 21.5M20.9999 15.5V33.5" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadCloudIcon; 